import lang from '@data/lang.json'
import {mapState} from 'vuex'

const PriceCTA = {
  // Props
  props: ['installationPrice', 'price'],
  // Data
  data() {
    return {
      addToCartClick: false,
      iconType: 'default',
      inputValue: 1,
      isMobile: false,
      lang: lang.ProductPresentation.ButtonText,
    }
  },
  // Computed
  computed: {
    ...mapState({
      status: state => state.cart.status,
    }),
  },
  // Methods
  methods: {
    addToCartText: function () {
      let buttonText = ''

      if (this.isMobile) {
        // Mobile
        if (this.addToCartClick) {
          // Adding
          if (!this.status.loading) {
            if (this.status.error) {
              buttonText = !this.lang.Failed.Short
                ? 'Ajdå!'
                : this.lang.Failed.Short
              this.hideNotification()
            }
            if (this.status.success) {
              buttonText = !this.lang.AddedToCart.Short
                ? 'Tillagd'
                : this.lang.AddedToCart.Short
              this.hideNotification()
            }
          } else {
            buttonText = !this.lang.AddingToCart
              ? 'Lägger till...'
              : this.lang.AddingToCart
          }
        } else {
          // Default
          buttonText = !this.lang.AddToCart.Short
            ? 'Lägg till'
            : this.lang.AddToCart.Short
        }
      } else {
        // Desktop
        if (this.addToCartClick) {
          // Adding
          if (!this.status.loading) {
            if (this.status.error) {
              buttonText = !this.lang.Failed.Long
                ? 'Något gick fel!'
                : this.lang.Failed.Long
              this.hideNotification()
            }
            if (this.status.success) {
              buttonText = !this.lang.AddedToCart.Long
                ? 'Lagd i varukorg'
                : this.lang.AddedToCart.Long
              this.hideNotification()
            }
          } else {
            buttonText = !this.lang.AddingToCart
              ? 'Lägger till...'
              : this.lang.AddingToCart
          }
        } else {
          // Default
          buttonText = !this.lang.AddToCart.Long
            ? 'Lägg i varukorg'
            : this.lang.AddToCart.Long
        }
      }

      return buttonText
    },
    estimateText: function () {
      let buttonText = ''
      if (this.isMobile) {
        // Mobile
        buttonText = !this.lang.ContactForEstimation.Short
          ? 'Få offert'
          : this.lang.ContactForEstimation.Short
      } else {
        // Desktop
        buttonText = !this.lang.ContactForEstimation.Long
          ? 'Kontakta för offert'
          : this.lang.ContactForEstimation.Long
      }

      return buttonText
    },
    handleContact: function () {
      bus.$emit('toggle_estimation_form')
    },
    handleResize: function (windowSize) {
      this.isMobile = windowSize.width < 400
    },
    hideNotification: function () {
      setTimeout(() => {
        this.addToCartClick = false
      }, 2000)
    },
    updateCart: function () {
      this.addToCartClick = true
      bus.$emit('updateCart')
    },
    updateInputValue: function () {
      bus.$emit('updateQuantity', this.inputValue)
    },
  },
  // Life cycle
  created() {
    bus.$on('window_resize', windowSize => {
      this.handleResize(windowSize)
    })
  },
}

export default PriceCTA
